export default __webpack_public_path__ + "static/2NEWPARKING-3e09e92b4d217c6956333ec15dfb7f88.png";